var identity = function identity(x) {
  return x;
};

export default identity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/identity.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7